import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Card,
  TableContainer,
  Paper,
  Checkbox,
  Button,
  Typography,
  Box,
} from "@mui/material";

function OrdersList() {
  const navigate = useNavigate();
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [orders] = useState([
    {
      id: 1,
      order_id: "107440964",
      subscriptionId: "154789/459",
      product: "HRMS",
      payment_amount: "₹ 1500",
      due_on: "19 Sep 2024",
      subscription_type: "Starter",
      status: "Active",
    },
  ]);

  const handleCheckboxChange = (orderId) => {
    setSelectedOrders((prevSelectedOrders) => {
      if (prevSelectedOrders.includes(orderId)) {
        return prevSelectedOrders.filter((id) => id !== orderId);
      } else {
        return [...prevSelectedOrders, orderId];
      }
    });
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "Active":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Active"
            color="success"
          />
        );
      case "Inactive":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Inactive"
            color="warning"
          />
        );
      case "Expired":
        return (
          <Chip variant="outlined" size="small" label="Expired" color="error" />
        );
      default:
        return <Chip variant="outlined" size="small" label={status} />;
    }
  };

  const calculateTotalAmount = () => {
    const totalAmount = orders
      .filter((order) => selectedOrders.includes(order.id))
      .reduce(
        (total, order) =>
          total + parseFloat(order.payment_amount.replace("₹ ", "")),
        0
      );
    return `₹ ${totalAmount}`;
  };

  const handleProceed = () => {
    navigate("/checkout");
  };

  return (
    <Card elevation={4}>
      <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 650, textAlign: "center" }}>
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Order ID</TableCell>
              <TableCell align="center">Business Subscription ID</TableCell>
              <TableCell align="center">Product Name</TableCell>
              <TableCell align="center">Subscription Type</TableCell>
              <TableCell align="center">Payment Amount</TableCell>
              <TableCell align="center">Due On</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((order, index) => (
              <TableRow key={order.id}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">{order.order_id}</TableCell>
                <TableCell align="center">{order.subscriptionId}</TableCell>
                <TableCell align="center">{order.product}</TableCell>
                <TableCell align="center">{order.subscription_type}</TableCell>
                <TableCell align="center">{order.payment_amount}</TableCell>
                <TableCell align="center">{order.due_on}</TableCell>
                <TableCell align="center">
                  {getStatusLabel(order.status)}
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={selectedOrders.includes(order.id)}
                    onChange={() => handleCheckboxChange(order.id)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedOrders.length > 0 && (
        <Box sx={{ p: 2, textAlign: "right" }}>
          <Typography variant="h6">
            Total Amount: {calculateTotalAmount()}
          </Typography>
          <Button
            variant="contained"
            sx={{
              mt: 2,
              width: "auto", 
              background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
              color: "#fff",
              borderRadius: "8px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              textTransform: "uppercase",
              fontWeight: "bold",
              "&:hover": {
                background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
              },
            }}
            onClick={handleProceed}
          >
            Proceed to Pay
          </Button>
        </Box>
      )}
    </Card>
  );
}

export default OrdersList;
